import { render, staticRenderFns } from "./HUD.vue?vue&type=template&id=1c3a2a84&scoped=true&"
import script from "./HUD.vue?vue&type=script&lang=js&"
export * from "./HUD.vue?vue&type=script&lang=js&"
import style0 from "./HUD.vue?vue&type=style&index=0&id=1c3a2a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a2a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
